import { apiPost } from "../client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { IApiResponse } from "../client";

// 성적표 일괄 생성 응답 인터페이스
export interface IGenerateReportsResponse {
  total_students: number;
  completed_exams: number;
  generated_reports: number;
  already_exists: number;
  failed_generations: number;
  details: {
    user_id: string;
    user_name: string;
    status: "success" | "already_exists" | "not_completed" | "failed";
    report_id?: string;
    error_msg?: string;
  }[];
}

/**
 * 시험 과제의 성적표 일괄 생성 API 함수
 * @param examAssignmentId 시험 과제 ID
 * @returns API 응답
 */
export const apiGenerateReports = async (
  examAssignmentId: string
): Promise<IApiResponse<IGenerateReportsResponse>> => {
  return apiPost(`/exam_assignments/${examAssignmentId}/generate-reports`);
};

/**
 * 성적표 일괄 생성 React Query 훅
 * @returns 뮤테이션 객체
 */
export const useMutationGenerateReports = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: apiGenerateReports,
    onSuccess: (_, examAssignmentId) => {
      // 관련된 쿼리들을 무효화하여 최신 데이터로 업데이트
      queryClient.invalidateQueries({
        queryKey: ["examAssignment", examAssignmentId],
      });
      queryClient.invalidateQueries({
        queryKey: ["examAssignments"],
      });
    },
  });
};
